function updateInfoFunc(event, booleanText) {
  // Get the parent element
  let parentElem = event.closest(".product--below-content");
  let mainParentElem = event.closest(".card-wrapper");

  // Get all variant elements and remove 'selected' class
  let variantParentElem = event.closest(".card--variant--wrapper").querySelectorAll(".card-variant-wrapper");
  variantParentElem.forEach((variant) => {
    variant.classList.remove("selected");
  });

  // Add 'selected' class to the clicked variant
  event.classList.add("selected");
  const variantId = event.getAttribute("data-varid");
  const priceAttr = event.getAttribute("data-price");
  const comparePriceAttr = event.getAttribute("data-comprice");
  const mem_discount_percentage = event.getAttribute("data-membershipamount");
  const hasDiscountAttr = event.hasAttribute("data-discount"); // ✅ Check if discount attribute exists
  const discountAttr = hasDiscountAttr ? event.getAttribute("data-discount") : null;

  // Parse price values only if attributes are present
  const price = priceAttr ? parseFloat(priceAttr.replace(/,/g, "")) : null;
  const comparePrice = comparePriceAttr ? parseFloat(comparePriceAttr.replace(/,/g, "")) : null;
  const discount = discountAttr ? parseFloat(discountAttr) : null;
  const memDiscount = mem_discount_percentage ? parseFloat(mem_discount_percentage) : null;

  // Update the price, compare price, and discount values
  if (mainParentElem) {
    let mobileAtcElem = mainParentElem.querySelector('#mobile-atc-wrapper input[name="id"]');
    let quickButtonWrapper = mainParentElem.querySelectorAll('.quick-add__submit');
    let swymNotifyButton = mainParentElem.querySelector('#sym-notify-button');
    let swymNotifyButtonMob = mainParentElem.querySelector('#sym-notify-button-mob');
    if (mobileAtcElem) {
      mobileAtcElem.value = variantId;
    }

    if(swymNotifyButton){
      swymNotifyButton.setAttribute("data-variant-id", variantId);
      if(booleanText){
        swymNotifyButton.style.display="none";
      }else{
        swymNotifyButton.style.display="block";
      }
    }
   if(swymNotifyButtonMob){
    swymNotifyButtonMob.setAttribute("data-variant-id", variantId);
    if(booleanText){
      swymNotifyButtonMob.style.display="none";
    }else{
      swymNotifyButtonMob.style.display="block";
    }
   }
   
   quickButtonWrapper?.forEach((atc) => {
    let atcButtonText = atc.querySelector('#desktop--atc-button-wrapper');
    let atcMobButtonText = atc.querySelector('#mob--atc-button-wrapper');
  
    if (!booleanText) {
      atc.style.display = 'none';
      atc.setAttribute('disabled', 'true');
  
      if (atcButtonText) atcButtonText.innerHTML = 'Sold out';
      if (atcMobButtonText) atcMobButtonText.innerHTML = 'Sold out';
    } else {
      atc.removeAttribute('disabled');
      atc.style.display = 'block';
  
      if (atcButtonText) atcButtonText.innerHTML = 'Add To Bag';
      if (atcMobButtonText) atcMobButtonText.innerHTML = '+ Add';
    }
  });
    
  }
  if (parentElem) {
    let variantInput = parentElem.querySelector('.quick-add input[name="id"]');
    let compare_price_elem = parentElem.querySelector(".compare-at-price");
    let original_price_elems = parentElem.querySelectorAll(".original--price");
    let discountWrapElems = parentElem.querySelectorAll(".card_product_price_percentoff");
    let memberDiscountElems = parentElem.querySelectorAll("#member_price");
    let customPriceContainers = parentElem.querySelectorAll(".custom_price__container");

    if (customPriceContainers) {
      customPriceContainers.forEach((container) => {
        container.style.transition = "none";
        container.style.opacity = "0";

        setTimeout(() => {
          container.style.transition = "opacity 0.5s ease-in-out";
          container.style.opacity = "1";
        }, 10);
      });
    }

    // ✅ Update the hidden input value with the variant ID
    if (variantInput) {
      variantInput.value = variantId;
    } else {
      console.error("Input[name='id'] not found inside .quick-add");
    }

    // ✅ Update all original price elements if data-price is present
    if (original_price_elems && price !== null) {
      original_price_elems.forEach((elem) => {
        elem.innerHTML = `₹${price.toLocaleString()}`;
      });
    }

    if (compare_price_elem) {
      if (comparePrice !== null && comparePrice > 0 && price !== null && comparePrice > price) {
        compare_price_elem.innerHTML = `₹${comparePrice.toLocaleString()}`;
        compare_price_elem.style.display = "block";
      } else {
        compare_price_elem.style.display = "none";
      }
    }

    if (discountWrapElems && discountWrapElems.length > 0) {
      discountWrapElems.forEach((discountWrap) => {
        if (hasDiscountAttr && discount !== null && discount > 0) {
          discountWrap.innerHTML = `${discount}% off`;
          discountWrap.style.display = "inline-block";
        } else {
          discountWrap.style.display = "none"; // Hide if attribute missing or value invalid
        }
      });
    }

    // ✅ Update member discount elements if present and valid
    if (memberDiscountElems && memDiscount !== null && memDiscount > 0) {
      memberDiscountElems.forEach((elem) => {
        elem.innerHTML = `₹${memDiscount}`;
        elem.style.display = "block";
      });
    } else {
      memberDiscountElems.forEach((elem) => {
        elem.style.display = "none";
      });
    }
  } else {
    console.error("Parent element .product--below-content not found");
  }
}

